import { useNavigate } from 'react-router-dom';
import type { ApplicationSummary } from '../api/client';
import StatusBadge from './StatusBadge';

function formatSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export default function ApplicationTable({
  applications,
  showJob = false,
}: {
  applications: ApplicationSummary[];
  showJob?: boolean;
}) {
  const navigate = useNavigate();
  if (applications.length === 0) return <p className="muted">No candidates yet.</p>;

  return (
    <table className="table">
      <thead>
        <tr>
          <th>Candidate</th>
          {showJob && <th>Job</th>}
          <th>Status</th>
          <th>CV</th>
          <th>Proposed by</th>
        </tr>
      </thead>
      <tbody>
        {applications.map((a) => (
          <tr key={a.id} className="row-link" onClick={() => navigate(`/applications/${a.id}`)}>
            <td>
              <div className="user-name">{a.candidate.fullName}</div>
              <div className="muted small">{a.candidate.email}</div>
            </td>
            {showJob && <td>{a.job.title}</td>}
            <td><StatusBadge status={a.status} /></td>
            <td className="muted small">{a.cv ? formatSize(a.cv.sizeBytes) : '—'}</td>
            <td className="muted small">{a.proposedBy.displayName}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
